import React, { createContext, useContext, useState, useCallback } from 'react';

const SessionContext = createContext(null);

// Global trigger function for use outside of React components (e.g., in baseApi.js)
let globalSessionExpiredCallback = null;

export const triggerSessionExpired = () => {
    if (globalSessionExpiredCallback) {
        globalSessionExpiredCallback();
    }
};

export const SessionProvider = ({ children }) => {
    const [isSessionExpired, setIsSessionExpired] = useState(false);

    const handleSessionExpired = useCallback(() => {
        // Only trigger if not already expired (prevent multiple modals)
        setIsSessionExpired(true);
    }, []);

    const clearSessionExpired = useCallback(() => {
        setIsSessionExpired(false);
    }, []);

    // Register the global callback
    React.useEffect(() => {
        globalSessionExpiredCallback = handleSessionExpired;
        return () => {
            globalSessionExpiredCallback = null;
        };
    }, [handleSessionExpired]);

    const value = {
        isSessionExpired,
        handleSessionExpired,
        clearSessionExpired
    };

    return (
        <SessionContext.Provider value={value}>
            {children}
        </SessionContext.Provider>
    );
};

export const useSession = () => {
    const context = useContext(SessionContext);
    if (!context) {
        throw new Error('useSession must be used within a SessionProvider');
    }
    return context;
};

export default SessionContext;
